
  import { mapGetters } from 'vuex';
  import { defineComponent } from 'vue';
  import { AppBadge } from '@/components';
  import CourseTypeMixin from '@/mixins/course-type-mixin';

  import type { PropType } from 'vue';
  import type { CourseType } from '@/typings/course';

  export default defineComponent({
    name: 'CourseTypeBadge',

    components: {
      AppBadge,
    },

    mixins: [
      CourseTypeMixin,
    ],

    props: {
      courseType: {
        type: Object as PropType<CourseType>,
        required: true,
      },

      courseIsAvailableForAllStudentsOfThisDomain: {
        type: Boolean as PropType<boolean>,
        default: false,
      },
    },

    computed: {
      ...mapGetters([
        'isGinkelCompany',
      ]),

      isKnowledgeMeeting(): boolean {
        return this.isGinkelCompany && this.courseIsAvailableForAllStudentsOfThisDomain;
      },

      badgeColorProfileDomClasses(): string[] {
        if (this.isKnowledgeMeeting) {
          return ['bg-red-100', 'text-red-900'];
        }

        const colors = this.getColors(this.courseType.colorProfile);

        return [colors.backgroundColor, colors.textColor];
      },
    },
  });
